function createReducer(handlers) {
    return function reducer(state, action) {
        if (handlers.hasOwnProperty(action.type)) {
            return handlers[action.type](state, action);
        }
        return state;
    };
}

function iniMotoscat(state, action) {
    return {
        ...state,
        motoscat: {
            idMarcaArticulo: null,
            idMarca: null,
            idModelo: null,
            idMotor: null,
            openCesta: false,
            openConfig: false,
            openHistorial: false,
            openMarcaArticulo: false,
            OEM: {
                codigoOEM: null,
                marcaOEM: null,
            },
            view: null,
            cliente: {},
            articulosGM: [],
            stateEquiv: true,
            openDrawer: false,
        },
    };
}

function setMarca(state, action) {
    return {
        ...state,
        motoscat: {
            ...state.motoscat,
            idMarca: action.idMarca,
            marca: action.marca,
        },
    };
}

function setMarcaArticulo(state, action) {
    return {
        ...state,
        motoscat: {
            ...state.motoscat,
            idMarcaArticulo: action.idMarcaArticulo,
            marcaArticulo: action.marca,
        },
    };
}

function setCC(state, action) {
    return {
        ...state,
        motoscat: {
            ...state.motoscat,
            cc: action.cc,
        },
    };
}

function setModelo(state, action) {
    return {
        ...state,
        motoscat: {
            ...state.motoscat,
            // idModelo: action.idModelo,
            modelo: action.modelo,
            version: action.version,
        },
    };
}

function setAnyo(state, action) {
    return {
        ...state,
        motoscat: {
            ...state.motoscat,
            anyo: action.year,
        },
    };
}

function setMotor(state, action) {
    return {
        ...state,
        motoscat: {
            ...state.motoscat,
            idMotor: action.idMotor,
            motor: action.motor,
            view: action.view,
        },
    };
}

function openMotoscat(state, action) {
    return {
        ...state,
        motoscat: {
            ...state.motoscat,
            open: true,
            view: action.view,
        },
    };
}

function closeMotoscat(state, action) {
    return {
        ...state,
        motoscat: {
            idMarcaArticulo: null,
            idMarca: null,
            idModelo: null,
            idMotor: null,
            OEM: null,
            view: null,
            openCesta: false,
            openConfig: false,
            openHistorial: false,
            openMarcaArticulo: false,
            cliente: {},
            articulosGM: [],
            grupoMontaje: {
                codigo: null,
                descripcion: null,
            },
        },
    };
}

function viewCesta(state, action) {
    return {
        ...state,
        motoscat: {
            ...state.motoscat,
            openCesta: action.open,
        },
    };
}

function viewConfig(state, action) {
    return {
        ...state,
        motoscat: {
            ...state.motoscat,
            openConfig: action.open,
        },
    };
}

function viewReportBug(state, action) {
    return {
        ...state,
        motoscat: {
            ...state.motoscat,
            openReportBug: action.open,
        },
    };
}

function viewHistorial(state, action) {
    return {
        ...state,
        motoscat: {
            ...state.motoscat,
            openHistorial: action.open,
        },
    };
}

function setMoto(state, action) {
    return {
        ...state,
        motoscat: {
            ...state.motoscat,
            idMarca: action.idMarca,
            idModelo: action.idModelo,
            idMotor: action.idMotor,
            marca: action.marca,
            modelo: action.modelo,
            motor: action.motor,
            anyo: action.anyo,
            cc: action.cc,
        },
    };
}

function setMotoDrawer(state, action) {
    return {
        ...state,
        motoscat: {
            ...state.motoscat,
            idMarca: action.idMarca,
            idModelo: action.idModelo,
            idMotor: action.idMotor,
            marca: action.marca,
            modelo: action.modelo,
            motor: action.motor,
            cc: action.cc,
            anyo: action.anyo,
            openDrawer: action.drawer,
            articulosGM: [],
            grupoMontaje: {
                codigo: null,
                descripcion: null,
            },
        },
    };
}

function setReferencia(state, action) {
    return {
        ...state,
        motoscat: {
            ...state.motoscat,
            referencia: action.referencia,
            articulosGM:
                action.referencia === '' ? state.motoscat.articulosGM : [],
            grupoMontaje:
                action.referencia === ''
                    ? state.motoscat.grupoMontaje
                    : {
                          codigo: null,
                          descripcion: null,
                      },
        },
    };
}

function setOEM(state, action) {
    return {
        ...state,
        motoscat: {
            ...state.motoscat,
            OEM: {
                ...state.motoscat.OEM,
                codigoOEM: action.codigoOEM,
                marcaOEM: action.marcaOEM,
            },
        },
    };
}

function setCliente(state, action) {
    return {
        ...state,
        motoscat: {
            ...state.motoscat,
            cliente: {
                ...action.reg,
            },
        },
    };
}

function setGruposMontajes(state, action) {
    return {
        ...state,
        motoscat: {
            ...state.motoscat,
            gruposMontaje: action.gruposMontaje,
        },
    };
}

function setSearchEquiv(state, action) {
    return {
        ...state,
        motoscat: {
            ...state.motoscat,
            stateEquiv: action.value,
        },
    };
}

function setGM(state, action) {
    return {
        ...state,
        motoscat: {
            ...state.motoscat,
            idMotor: action.idMotor,
            motor: action.motor,
            view: action.view,
            articulosGM: action.articulos,
            grupoMontaje: action.grupoMontaje,
            // {
            //     codigo: action.codigoGM,
            //     descripcion: action.descripcionGM,
            // },
            openDrawer: false,
        },
    };
}

function resetArticulosGM(state, action) {
    return {
        ...state,
        motoscat: {
            ...state.motoscat,
            articulosGM: [],
            grupoMontaje: [],
            // {
            //     codigo: null,
            //     descripcion: null,
            // },
        },
    };
}

function drawerAction(state, action) {
    return {
        ...state,
        motoscat: {
            ...state.motoscat,
            openDrawer: action.drawer,
        },
    };
}

const motoscatReducer = createReducer({
    INI_MOTOSCAT: iniMotoscat,
    SET_MARCA: setMarca,
    SET_YEAR: setAnyo,
    SET_CC: setCC,
    SET_MARCA_ARTICULO: setMarcaArticulo,
    SET_MODELO: setModelo,
    SET_MOTOR: setMotor,
    SET_GRUPO_MONTAJE: setGM,
    RESET_GRUPO_MONTAJE: resetArticulosGM,
    OPEN_MOTOSCAT: openMotoscat,
    CLOSE_MOTOSCAT: closeMotoscat,
    VIEW_CESTA_MOTOSCAT: viewCesta,
    VIEW_CONFIG: viewConfig,
    VIEW_REPORT_BUG: viewReportBug,
    VIEW_HISTORIAL: viewHistorial,
    SET_MOTO: setMoto,
    SET_MOTO_DRAWER: setMotoDrawer,
    SET_REFERENCIA: setReferencia,
    SET_OEM: setOEM,
    SET_CLIENTE: setCliente,
    SET_GRUPOS_MONTAJE: setGruposMontajes,
    SET_SEARCH_EQUIV: setSearchEquiv,
    DRAWER_ACTION: drawerAction,
});

export default motoscatReducer;
